import { Chip } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TAssetStage } from '@brickwise/asset-validation/dist/schema/enums';

export const AssetStatus: FC<{ status: TAssetStage | undefined }> = ({ status }) => {
  const { t } = useTranslation();
  switch (status) {
    case 'preparing':
      return <Chip label={t('dashboard.assets.status.preparing')} sx={{ color: 'rgb(30 66 159)', backgroundColor: 'rgb(225 239 254)' }} />;
    case 'preorder':
      return <Chip label={t('dashboard.assets.status.preorder')} sx={{ color: 'rgb(112,30,159)', backgroundColor: 'rgb(236,225,254)' }} />;
    case 'review':
      return <Chip label={t('dashboard.assets.status.review')} sx={{ color: 'rgb(114 59 19)', backgroundColor: 'rgb(253 246 178)' }} />;
    case 'approved':
      return <Chip label={t('dashboard.assets.status.approved')} sx={{ color: 'rgb(3 84 63)', backgroundColor: 'rgb(222 247 236)' }} />;
    case 'declined':
      return <Chip label={t('dashboard.assets.status.declined')} sx={{ color: 'rgb(155 28 28)', backgroundColor: 'rgb(253 232 232)' }} />;
    case 'primary':
      return <Chip label={t('dashboard.assets.status.primary')} />;
    default:
      return <></>;
  }
};
